import React, { useState, useEffect, useRef } from 'react';
import { signInWithPopup, onAuthStateChanged, signOut } from 'firebase/auth';
import { auth, googleProvider } from '../../../firebase/firebase';
import { Phone, FileText, Mic, Play, ArrowRight, User, LogOut, Shuffle, SkipBack, Pause, SkipForward, Volume2, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Login Component
const LoginScreen = ({ onLoginSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

const slides = [
      {
    title: "Welcome To Preptune",
    tiles: ["/videos/intro-video.mp4"],
    background: "linear-gradient(135deg, #dcdeeb8d, #83bdf1)",
    titleColor: "#09236aff",
    titleBg: "#d6e8ffff",
    split: "#a3b7d4ff",
  },
      {
    tiles: ["/videos/slide-video.mp4"],
    background: "linear-gradient(135deg, #ffecd2, #fcb69f)",
    title: "How It Works",
    titleColor: "#d35510ff",
    titleBg: "rgba(255, 239, 231, 0.5)",
    split: "#deac95ff",
  },  
        {
      title: "Jounraling Made Easy",
      tiles: [
        "/image/guy10.jpeg",
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400",
      ],
          titleColor: "#0e7970ff",
    titleBg: "rgba(255, 255, 255, 0.89)",
    background: "linear-gradient(135deg, #c2c4d8ff, #9992f9ac)",
    split: "#9ca3daff",
    }, 
];
  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      onLoginSuccess(result.user);
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleVideoPlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoEnded = () => {
    setIsPlaying(false);
    nextSlide();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPlaying) {
        nextSlide();
      }
    }, isPlaying ? 23000 : 3000);

    return () => clearInterval(interval);
  }, [currentIndex, isPlaying, slides]);

  const nextSlide = () => {
    setFade(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
      setIsPlaying(false);
      setTimeout(() => setFade(false), 50);
    }, 300);
  };
  
  const prevSlide = () => {
    setFade(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
      setIsPlaying(false);
      setTimeout(() => setFade(false), 50);
    }, 300);
  };
    const getCustomTileStyle = (index) => {
    switch (index) {
      case 0:
        return "tile-style-0";
      case 1:
        return "tile-style-1";
      case 2:
        return "tile-style-2";
      default:
        return "";
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#e8e8e8',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: '12px',
        padding: '3rem',
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%',
        margin: '2rem',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 2rem auto'
        }}>
                <img style={{
          width: '40px',
          height: '40px',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          top:'15px',
          justifyContent: 'center',
          margin: '0 auto 2rem auto'
        }} src="/image/logo.png" alt="Logo" className="logo" />
                </div>
        
        <h1 style={{
          fontSize: '1.7rem',
          fontWeight: '500',
          color: '#5a5a5a',
          margin: '0 0 3rem 0'
        }}>
          Welcome to Preptune
        </h1>
        
        <p style={{
          fontSize: '0.95rem',
          color: '#8a8a8a',
          margin: '0 0 2rem 0',
          lineHeight: '1.5'
        }}>
          Thanks for testing out our BETA!
        </p>
             <p style={{
          fontSize: '0.95rem',
          color: '#8a8a8a',
          margin: '0 0 2rem 0',
          lineHeight: '1.5',
          
        }}>
         We are expecting your feedback to make our platform better.
        </p>   
        <button
          onClick={handleGoogleSignIn}
          disabled={isLoading}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
            width: '100%',
            padding: '1rem 1.5rem',
            backgroundColor: '#4285f4',
            color: '#ffffff',
            border: 'none',
            borderRadius: '12px',
            fontSize: '0.85rem',
            fontWeight: '500',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease',
            opacity: isLoading ? 0.7 : 1
          }}
        >
          {isLoading ? (
            <>
              <div style={{
                width: '20px',
                height: '20px',
                border: '2px solid #ffffff',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }} />
              Signing in...
            </>
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </>
          )}
        </button>
      </div>
                                        <div className="splitt-bar" draggable="false"          style={{ 
      backgroundColor: slides[currentIndex].split}}></div>
                    <div className="display-section">
        <div 
          className={`slideshow-container ${fade ? 'fade' : ''}`}
          style={{ background: slides[currentIndex].background }}
        >
          <div className={`tiles-grid ${fade ? 'fade' : ''}`}>
            {slides[currentIndex].tiles.map((tile, index) => {
              const isVideo = tile.endsWith(".mp4");
              const customClass = slides[currentIndex].title === "Create your own 3D scenarios By Prompting Emma"
                ? getCustomTileStyle(index)
                : "";

              return isVideo ? (
                <div key={index} className="video-wrapper">
                  <div className={`tile-video-container ${customClass}`}>
                    <video
                      ref={videoRef}
                      src={tile}
                      className="tile-video"
                      onEnded={handleVideoEnded}
                    />
                    <div className="video-title">
                    <button 
                      onClick={handleVideoPlay} 
                      className="playbutton"
                    >
                      Play
                    </button>                    </div>
                  </div>
                </div>
              ) : (
                <div className={`tile ${customClass}`} key={index}>
                  <img src={tile} alt={`Tile ${index}`} className="tile-image" />
                </div>
              );
            })}
          </div>

<div className="slide-info">
  <h2
    className="slide-title"
    style={{
      color: slides[currentIndex].titleColor,
      backgroundColor: slides[currentIndex].titleBg,
      padding: "5px 16px",
      borderRadius: "38px",
      display: "inline-block",
    }}
  >
    {slides[currentIndex].title}
  </h2>
  {slides[currentIndex].description && (
    <p className="slide-description">{slides[currentIndex].description}</p>
  )}
</div>

      {/* Navigation buttons */}
      <div className="navigation-buttons">
        <button className="prev" onClick={prevSlide}>
          &#8592;
        </button>
        <button className="next" onClick={nextSlide}>
          &#8594;
        </button>
      </div>
        </div>
      </div>
    </div>
  );
};

// Voice Selection Component
const VoiceSelection = ({ user, onVoiceSelected }) => {
  const [selectedVoice, setSelectedVoice] = useState(null);

  const voices = [
    {
      id: 'emma',
      name: 'Emma',
      description: 'Warm and empathetic, perfect for deep conversations and emotional support',
      personality: 'Caring • Intuitive • Patient',
      color: '#e8f4f8'
    },
    {
      id: 'alex',
      name: 'Alex',
      description: 'Direct and motivating, great for goal-setting and actionable insights',
      personality: 'Focused • Encouraging • Clear',
      color: '#f0f8e8'
    }
  ];

  const handleContinue = () => {
    if (selectedVoice) {
      onVoiceSelected(selectedVoice);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#e8e8e8',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      padding: '1rem'
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: '24px',
        padding: window.innerWidth <= 768 ? '2rem 1.5rem' : '3rem',
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}>
        <h1 style={{
          fontSize: window.innerWidth <= 768 ? '1.5rem' : '2rem',
          fontWeight: '500',
          color: '#5a5a5a',
          margin: '0 0 1rem 0'
        }}>
          Choose Your AI Companion
        </h1>
        
        <p style={{
          fontSize: window.innerWidth <= 768 ? '0.9rem' : '1rem',
          color: '#8a8a8a',
          margin: '0 0 2rem 0',
          lineHeight: '1.5'
        }}>
          Select the voice assistant that resonates with you. You can change this anytime.
        </p>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '1fr 1fr',
          gap: window.innerWidth <= 768 ? '1rem' : '2rem',
          marginBottom: window.innerWidth <= 768 ? '2rem' : '3rem'
        }}>
          {voices.map((voice) => (
            <div
              key={voice.id}
              onClick={() => setSelectedVoice(voice.id)}
              style={{
                background: selectedVoice === voice.id ? voice.color : '#f8f8f8',
                borderRadius: '16px',
                padding: window.innerWidth <= 768 ? '1.5rem' : '2rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: selectedVoice === voice.id ? '2px solid #5a5a5a' : '2px solid transparent',
                textAlign: 'left'
              }}
            >
              <div style={{
                width: window.innerWidth <= 768 ? '50px' : '60px',
                height: window.innerWidth <= 768 ? '50px' : '60px',
                borderRadius: '50%',
                backgroundColor: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 0 1.5rem 0',
                fontSize: window.innerWidth <= 768 ? '1.25rem' : '1.5rem'
              }}>
                {voice.id === 'emma' ? '👩‍💼' : '👨‍💼'}
              </div>
              
              <h3 style={{
                fontSize: window.innerWidth <= 768 ? '1.25rem' : '1.5rem',
                fontWeight: '500',
                color: '#5a5a5a',
                margin: '0 0 0.5rem 0'
              }}>
                {voice.name}
              </h3>
              
              <p style={{
                fontSize: window.innerWidth <= 768 ? '0.8rem' : '0.9rem',
                color: '#8a8a8a',
                margin: '0 0 1rem 0',
                lineHeight: '1.4'
              }}>
                {voice.description}
              </p>
              
              <div style={{
                fontSize: window.innerWidth <= 768 ? '0.75rem' : '0.8rem',
                color: '#999',
                fontStyle: 'italic'
              }}>
                {voice.personality}
              </div>
              
              {selectedVoice === voice.id && (
                <div style={{
                  marginTop: '1rem',
                  padding: '0.5rem',
                  backgroundColor: '#ffffff',
                  borderRadius: '8px',
                  fontSize: '0.8rem',
                  color: '#5a5a5a',
                  fontWeight: '500'
                }}>
                  ✓ Selected
                </div>
              )}
            </div>
          ))}
        </div>
        
        <button
          onClick={handleContinue}
          disabled={!selectedVoice}
          style={{
            padding: window.innerWidth <= 768 ? '0.75rem 1.5rem' : '1rem 2rem',
            backgroundColor: selectedVoice ? '#5a5a5a' : '#ccc',
            color: '#ffffff',
            border: 'none',
            borderRadius: '12px',
            fontSize: window.innerWidth <= 768 ? '0.9rem' : '1rem',
            fontWeight: '500',
            cursor: selectedVoice ? 'pointer' : 'not-allowed',
            transition: 'all 0.2s ease',
            width: window.innerWidth <= 480 ? '100%' : 'auto'
          }}
        >
          Continue to Dashboard
        </button>
      </div>
    </div>
  );
};

// Mock data for sessions
const mockSessions = [
  {
    id: 1,
    title: "Morning Reflection",
    duration: 147,
    image: "/image/session-img.png",
    audio: "/sound/convo1.mp3"
  },
  {
    id: 2,
    title: "Evening Thoughts",
    duration: 203,
    image: "/image/session-img4.png",
    audio: "/sound/convo2.mp3"
  },
  {
    id: 3,
    title: "Weekly Review",
    duration: 189,
    image: "/image/session-img3.png",
    audio: "/sound/convo3.mp3"
  }
];

const JourneyDashboard = ({ user, selectedVoice = 'default', onSignOut }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentSessionIndex, setCurrentSessionIndex] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const audioRef = useRef(null);



  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      const audio = audioRef.current;
      
      const updateTime = () => setCurrentTime(audio.currentTime);
      const updateDuration = () => setDuration(audio.duration);
      
      audio.addEventListener('timeupdate', updateTime);
      audio.addEventListener('loadedmetadata', updateDuration);
      audio.addEventListener('ended', handleNext);
      
      return () => {
        audio.removeEventListener('timeupdate', updateTime);
        audio.removeEventListener('loadedmetadata', updateDuration);
        audio.removeEventListener('ended', handleNext);
      };
    }
  }, [currentSessionIndex]);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  const getFirstName = () => {
    if (!user?.displayName) return 'there';
    return user.displayName.split(' ')[0];
  };

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleNext = () => {
    setCurrentSessionIndex((prev) => (prev + 1) % mockSessions.length);
    setIsPlaying(false);
    setCurrentTime(0);
  };

  const handlePrevious = () => {
    setCurrentSessionIndex((prev) => (prev - 1 + mockSessions.length) % mockSessions.length);
    setIsPlaying(false);
    setCurrentTime(0);
  };

  const handleSignOut = async () => {
    try {
      if (onSignOut) {
        await onSignOut();
      }
      setShowProfileDropdown(false);
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const progress = duration > 0 ? currentTime / duration : 0;
  const currentSession = mockSessions[currentSessionIndex];

  return (
    <div style={{
      height: '100vh',
      overflowY: 'auto',
      padding: isMobile ? '1rem' : '1rem',
      backgroundColor: '#e1e1e1ff',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      {/* Header with User Info */}
      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'flex-start' : 'center',
        marginBottom: isMobile ? '1.5rem' : '2rem',
        gap: isMobile ? '1rem' : '0'
      }}>
        {/* Mobile Header Layout */}
        {isMobile ? (
          <>
            {/* Profile Dropdown - Top Right on Mobile */}
            <div style={{ 
              alignSelf: 'flex-end',
              position: 'relative'
            }}>
              <div 
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 1rem',
                  backgroundColor: '#ffffff',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                  border: '1px solid #e0e0e0'
                }}
              >
                <img 
                  src={user?.photoURL} 
                  alt={user?.displayName}
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%'
                  }}
                />
                <span style={{ color: '#2a2a2a' }}>{getFirstName()}</span>
                <ChevronDown size={16} style={{ color: '#666' }} />
              </div>
              
              {showProfileDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  right: '0',
                  marginTop: '0.5rem',
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                  border: '1px solid #e0e0e0',
                  minWidth: '160px',
                  zIndex: 1000
                }}>
                  <div style={{
                    padding: '0.75rem 1rem',
                    borderBottom: '1px solid #f0f0f0'
                  }}>
                    <div style={{ fontSize: '0.85rem', color: '#666' }}>Signed in as</div>
                    <div style={{ fontSize: '0.9rem', color: '#2a2a2a', fontWeight: '500' }}>
                      {user?.displayName}
                    </div>
                  </div>
                  <button
                    onClick={handleSignOut}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      padding: '0.75rem 1rem',
                      backgroundColor: 'transparent',
                      color: '#666',
                      border: 'none',
                      fontSize: '0.9rem',
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    <LogOut size={15} />
                    Sign Out
                  </button>
                </div>
              )}
            </div>
            
            {/* Greeting Text */}
            <div style={{ width: '100%' }}>
              <h1 style={{
                fontSize: '1.4rem',
                fontWeight: '400',
                color: '#1a1a1a',
                margin: '0 0 0.5rem 0',
                letterSpacing: '0.02em',
                marginBottom: '5px'
              }}>
                {getGreeting()}, {getFirstName()}
              </h1>
              <p style={{
                fontSize: '0.9rem',
                color: '#5e5e5eff',
                margin: 0,
                fontWeight: '400',
                textAlign: 'center',
              }}>
                Your space to reflect, and grow 
              </p>
            </div>
          </>
        ) : (
          /* Desktop Layout */
          <>
            <div>
              <h1 style={{
                fontSize: '1.7rem',
                fontWeight: '400',
                color: '#545454ff',
                margin: '0 0 0.5rem 0',
                letterSpacing: '0.02em',
                marginBottom: '3px'
              }}>
                {getGreeting()}, {getFirstName()}
              </h1>
              <p style={{
                fontSize: '0.9rem',
                color: '#787878ff',
                margin: 0,
                fontWeight: '400',
                textAlign: 'left',
              }}>
                Your space to reflect, and grow 
              </p>
            </div>
            
            {/* Profile Dropdown - Desktop */}
            <div style={{ position: 'relative' }}>
              <div 
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 1rem',
                  backgroundColor: '#ffffff',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                  border: '1px solid #e0e0e0'
                }}
              >
                <img 
                  src={user?.photoURL} 
                  alt={user?.displayName}
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%'
                  }}
                />
                <span style={{ color: '#2a2a2a' }}>{getFirstName()}</span>
                <ChevronDown size={16} style={{ color: '#666' }} />
              </div>
              
              {showProfileDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  right: '0',
                  marginTop: '0.5rem',
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                  border: '1px solid #e0e0e0',
                  minWidth: '160px',
                  zIndex: 1000
                }}>
                  <div style={{
                    padding: '0.75rem 1rem',
                    borderBottom: '1px solid #f0f0f0'
                  }}>
                    <div style={{ fontSize: '0.85rem', color: '#666' }}>Signed in as</div>
                    <div style={{ fontSize: '0.9rem', color: '#2a2a2a', fontWeight: '500' }}>
                      {user?.displayName}
                    </div>
                  </div>
                  <button
                    onClick={handleSignOut}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      padding: '0.75rem 1rem',
                      backgroundColor: 'transparent',
                      color: '#666',
                      border: 'none',
                      fontSize: '0.8rem',
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    <LogOut size={15} />
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 320px',
        gap: isMobile ? '1.5rem' : '2rem',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Left Column - Main Content */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: isMobile ? '1.5rem' : '2rem'
        }}>
          
          {/* Hero Card - Start Session */}
          <div style={{
            background: '#ffffffed',
            border: '1px solid #b9b9b9b9',
            borderRadius: '24px',
            padding: isMobile ? '1.5rem' : '2rem',
            color: '#2a2a2a',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            position: 'relative',
            bottom: isMobile ? '0px' : '20px',            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: isMobile ? '100px' : '100px',
            boxShadow: '0 4px 10px rgba(180, 180, 180, 0.91),inset 0 2px 0  rgba(255, 255, 255, 1)'
          }}
          onMouseEnter={(e) => {
            if (!isMobile) e.currentTarget.style.transform = 'translateY(-4px)';
          }}
          onMouseLeave={(e) => {
            if (!isMobile) e.currentTarget.style.transform = 'translateY(0)';
          }}>
            
            <div>
              <p style={{
                fontSize: isMobile ? '0.9rem' : '1rem',
                color: '#3b3b3bff',
                margin: 0,
                fontWeight: '400',
                marginBottom: isMobile ? '30px' : '30px'
              }}>
                What's on your mind today?
              </p>
            </div>
            
            <div
              onClick={() => window.location.href = `/chat/${selectedVoice}`}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: isMobile ? '0.6rem 1.25rem' : '0.75rem 1.5rem',
                backgroundColor: '#737373e8',
                borderRadius: '50px',
                fontSize: isMobile ? '0.8rem' : '0.9rem',
                color: '#ffffffff',
                fontWeight: '400',
                cursor: 'pointer',
                boxShadow: '0 4px 10px rgba(172, 172, 172, 0.2),inset 0 2px 0  rgba(178, 178, 178, 1)'
              }}
            >
              Start call
            </div>
          </div>

          {/* Past Sessions Card - Audio Player Style */}
          <div style={{
            position: 'relative',
            bottom: isMobile ? '0px' : '40px',
            boxShadow: '0 4px 10px rgba(180, 180, 180, 0.91),inset 0 2px 0  rgba(255, 255, 255, 1)',
            background: '#f8f8f8',
            borderRadius: '20px',
            padding: isMobile ? '1.5rem' : '1rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            border: '1px solid #b9b9b9b9',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center'
          }}>
            {/* Header */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1rem'
            }}>
              <h3 style={{
                fontSize: isMobile ? '1rem' : '0.9rem',
                fontWeight: '400',
                color: '#404040ff',
                margin: '0',
                textAlign: 'left'
              }}>
                past sessions
              </h3>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <span style={{ fontSize: '0.8rem', color: '#666' }}>
                  {currentSessionIndex + 1}/{mockSessions.length}
                </span>
                <div style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: isPlaying ? '#1682cfff' : '#666'
                }}></div>
              </div>
            </div>

            {/* Session Title */}
            <p style={{
              fontSize: '1rem',
              color: '#1a1a1a',
              margin: '0 0 0.5rem 0',
              textAlign: 'center',
              fontWeight: '500'
            }}>
              {currentSession.title}
            </p>

            {/* Status */}
            <p style={{
              fontSize: '0.9rem',
              color: '#666',
              margin: '0 0 1.5rem 0',
              textAlign: 'center'
            }}>
              {isPlaying ? 'Playing' : 'Paused'}
            </p>

            {/* Time Display */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
              marginBottom: '1.5rem',
              fontSize: '0.9rem',
              color: '#1a1a1a'
            }}>
              <span>{formatTime(currentTime)}</span>
              <span style={{ color: '#ccc' }}>|</span>
              <span>{formatTime(duration || currentSession.duration)}</span>
            </div>

            {/* Avatar with Progress Ring */}
            <div style={{
              position: 'relative',
              width: isMobile ? '100px' : '120px',
              height: isMobile ? '100px' : '120px',
              margin: '0 auto 1.5rem auto'
            }}>
              {/* Progress Ring */}
              <svg
                width={isMobile ? '100' : '120'}
                height={isMobile ? '100' : '120'}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
              >
                {/* Background Track */}
                <rect
                  x="5"
                  y="5"
                  width={isMobile ? '90' : '110'}
                  height={isMobile ? '90' : '110'}
                  rx="16"
                  ry="16"
                  fill="none"
                  stroke="#e0e0e0"
                  strokeWidth="2"
                />

                {/* Animated Progress */}
                <rect
                  x="5"
                  y="5"
                  width={isMobile ? '90' : '110'}
                  height={isMobile ? '90' : '110'}
                  rx="16"
                  ry="16"
                  fill="none"
                  stroke="#2a2a2a"
                  strokeWidth="2"
                  strokeDasharray={`${4 * (isMobile ? 90 : 110)}`}
                  strokeDashoffset={`${
                    4 * (isMobile ? 90 : 110) * (1 - progress)
                  }`}
                  style={{
                    transition: 'stroke-dashoffset 0.3s ease',
                  }}
                />
              </svg>
              
              {/* Avatar */}
              <div style={{
                position: 'absolute',
                top: '6px',
                left: '6px',
                width: isMobile ? '88px' : '108px',
                height: isMobile ? '88px' : '108px',
                borderRadius: '15%',
                overflow: 'hidden',
                border: '2px solid #fff'
              }}>
                <img 
                  src={currentSession.image} 
                  alt="Session"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            </div>

            {/* Control Buttons */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '1rem'
            }}>
              <button style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#666',
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Shuffle size={15} />
              </button>
              
              <button 
                onClick={handlePrevious}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#1a1a1a',
                  padding: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <SkipBack size={15} />
              </button>
              
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handlePlayPause();
                }}
                style={{
                  width: '45px',
                  height: '45px',
                  borderRadius: '50%',
                  backgroundColor: '#dadadaff',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#505050ff'
                }}
              >
                {isPlaying ? <Pause size={17} /> : <Play size={17} />}
              </button>
              
              <button 
                onClick={handleNext}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#1a1a1a',
                  padding: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <SkipForward size={15} />
              </button>
              
              <button style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#666',
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Volume2 size={15} />
              </button>
            </div>

            {/* Hidden Audio Element */}
            <audio
              ref={audioRef}
              src={currentSession.audio}
              style={{ display: 'none' }}
            />
          </div>
        </div>

        {/* Right Sidebar */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'row' : 'column',
          gap: '1.5rem',
          overflowX: isMobile ? 'auto' : 'visible'
        }}>
          {/* Journal Card - Reduced Height */}
          <div style={{
            background: '#ffffff',
            borderRadius: '20px',
            padding: '1rem',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
            minHeight: '60px',
            minWidth: isMobile ? '160px' : 'auto',
            textAlign: 'center',
            flex: isMobile ? '0 0 auto' : '1'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              backgroundColor: '#f5f5f5',
              color: '#666',
              margin: '0 auto 0.5rem auto'
            }}>
              <FileText size={16} />
            </div>

            <h3 style={{
              fontSize: '0.9rem',
              fontWeight: '500',
              color: '#1a1a1a',
              margin: '0 0 0.25rem 0'
            }}>
              Journal
            </h3>
            <p style={{
              fontSize: '0.7rem',
              color: '#4a4a4a',
              margin: '0',
              lineHeight: '1.3',
              fontWeight: '400'
            }}>
              Track your journey
            </p>
          </div>

          {/* To-do List Card - Reduced Height */}
          <div style={{
            background: '#ffffff',
            borderRadius: '20px',
            padding: '1rem',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
            minHeight: '60px',
            minWidth: isMobile ? '140px' : 'auto',
            textAlign: 'center',
            flex: isMobile ? '0 0 auto' : '1'
          }}>
            <div style={{
              fontSize: '0.6rem',
              fontWeight: '500',
              color: '#666',
              backgroundColor: '#f8f8f8',
              padding: '0.15rem 0.5rem',
              borderRadius: '8px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '0.5rem',
              display: 'inline-block'
            }}>
              TO-DO
            </div>
            <h3 style={{
              fontSize: '0.9rem',
              fontWeight: '500',
              color: '#1a1a1a',
              margin: '0 0 0.5rem 0'
            }}>
              Tasks
            </h3>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.3rem',
              alignItems: 'center'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem'
              }}>
                <div style={{
                  width: '4px',
                  height: '4px',
                  borderRadius: '50%',
                  backgroundColor: '#666'
                }}></div>
                <span style={{
                  fontSize: '0.65rem',
                  color: '#2a2a2a',
                  fontWeight: '400'
                }}>
                  Call mom
                </span>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem'
              }}>
                <div style={{
                  width: '4px',
                  height: '4px',
                  borderRadius: '50%',
                  backgroundColor: '#666'
                }}></div>
                <span style={{
                  fontSize: '0.65rem',
                  color: '#2a2a2a',
                  fontWeight: '400'
                }}>
                  Finish work
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Click outside to close dropdown */}
      {showProfileDropdown && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setShowProfileDropdown(false)}
        />
      )}
    </div>
  );
};


// Main App Component that handles the flow
const App = () => {
  const [currentStep, setCurrentStep] = useState('loading'); // 'loading', 'login', 'voice-selection', 'dashboard'
  const [user, setUser] = useState(null);
  const [selectedVoice, setSelectedVoice] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        // Check if voice was previously selected (you might want to store this in localStorage or database)
        const savedVoice = localStorage.getItem(`voice-${user.uid}`);
        if (savedVoice) {
          setSelectedVoice(savedVoice);
          setCurrentStep('dashboard');
        } else {
          setCurrentStep('voice-selection');
        }
      } else {
        setUser(null);
        setSelectedVoice(null);
        setCurrentStep('login');
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLoginSuccess = (user) => {
    setUser(user);
    setCurrentStep('voice-selection');
  };

  const handleVoiceSelected = (voice) => {
    setSelectedVoice(voice);
    // Save voice preference
    if (user) {
      localStorage.setItem(`voice-${user.uid}`, voice);
    }
    setCurrentStep('dashboard');
  };

  const handleSignOut = () => {
    setUser(null);
    setSelectedVoice(null);
    if (user) {
      localStorage.removeItem(`voice-${user.uid}`);
    }
    setCurrentStep('login');
  };

  if (currentStep === 'loading') {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#e8e8e8'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #f0f0f0',
          borderTop: '3px solid #5a5a5a',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
      </div>
    );
  }

  if (currentStep === 'login') {
    return <LoginScreen onLoginSuccess={handleLoginSuccess} />;
  }

  if (currentStep === 'voice-selection') {
    return <VoiceSelection user={user} onVoiceSelected={handleVoiceSelected} />;
  }

  if (currentStep === 'dashboard') {
    return <JourneyDashboard user={user} selectedVoice={selectedVoice} onSignOut={handleSignOut} />;
  }

  return null;
};

export default App;